import { Image } from '@mantine/core';
import { AuthWrapper, ResetPasswordForm } from 'src/components';
import PasswordImage from 'src/assets/images/lock.png';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from '@mantine/hooks';

const ResetPasswordPage = (): JSX.Element => {
  const [t] = useTranslation('auth');

  useDocumentTitle(t('resetPasswordPageTitle'));
  return (
    <AuthWrapper
      leftColumn={<Image style={{'filter': 'invert(20%) sepia(75%) saturate(5000%) hue-rotate(240deg)'}} maw={400} mx={'auto'} radius={'md'} src={PasswordImage} alt={'Lock image'} />}
      rightColumn={<ResetPasswordForm />}
    />
  );
};

export default ResetPasswordPage;
